import { InnoEcosystem, Nomad, School } from '@ice-web-app/assets';
import { DsTypography } from '@ice-web-app/designSystem';
import { TIPS } from '@ice-web-app/shared-constants';
import { useTranslation } from '@ice-web-app/shared-hooks';
import { useCurrentUserStore } from '@ice-web-app/shared-store';
import { Box, Stack } from '@mui/material';
import { Dispatch, FC, SetStateAction, useState } from 'react';
import SidebarIconFrame from '../SidebarIconFrame';
import EcosystemMenu from './EcosystemMenu';

interface Props {
  setMenu: Dispatch<SetStateAction<'ecosystem' | 'microSystem' | 'member' | 'none'>>;
}

const Ecosystem: FC<Props> = ({ setMenu }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setMenu('ecosystem');
  };
  const { currentEcosystem } = useCurrentUserStore();
  let ecosystemName = '';
  switch (currentEcosystem?.ecosystem) {
    case 'eco_innovation':
      ecosystemName = 'INNOVATION';
      break;
    case 'nomad':
      ecosystemName = 'NOMAD';
      break;
    case 'eco_school':
      ecosystemName = 'SCHOOL';
      break;
    default:
      ecosystemName = 'INNOVATION';
  }

  return (
    <>
      <Stack
        justifyContent="center"
        alignItems="center"
        gap={3.25}
        data-tour={TIPS.LAYOUT.SIDEBAR.MINI_SIDEBAR_INNOVATION_ECOSYSTEM.DATA}
      >
        <SidebarIconFrame handleClick={handleClick}>
          {/* TODO Check form problem in hot reload */}
          <Box />
          {currentEcosystem?.ecosystem === 'eco_innovation' && <InnoEcosystem />}
          {currentEcosystem?.ecosystem === 'eco_school' && <School />}
          {currentEcosystem?.ecosystem === 'nomad' && <Nomad />}
        </SidebarIconFrame>
        <DsTypography variant="body2_500" sx={{ fontSize: '0.625rem', textAlign: 'center', lineHeight: '16px' }}>
          {t('LABEL_ECOSYSTEM', {
            label: t(ecosystemName),
          })}
        </DsTypography>
      </Stack>
      <EcosystemMenu anchorEl={anchorEl} setAnchorEl={setAnchorEl} setMenu={setMenu} />
    </>
  );
};
export default Ecosystem;
